import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'
import myLibrarySchoolInviteConfirmSelector from 'redux/selectors/my_library/my_library_school_invite_confirm_selector'
import { localize } from 'helpers/translator'

const MyLibrarySchoolInviteConfirm = props => (
	<Confirm
		btTwo={localize('global_yes')}
		btOne={localize('global_no')}
		alertMessage={props.message}
		actionTwo={props.actions.schoolInviteConfirmYes}
		actionOne={props.actions.schoolInviteConfirmNo}
		closeAction={props.actions.closeSchoolInviteConfirm}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		schoolInviteConfirmYes: myLibraryActions.schoolInviteConfirmYes,
		schoolInviteConfirmNo: myLibraryActions.schoolInviteConfirmNo,
		closeSchoolInviteConfirm: myLibraryActions.closeSchoolInviteConfirm,
	}, dispatch)
}

function mapStateToProps(state) {
	return myLibrarySchoolInviteConfirmSelector(state)
}

export default connect(mapStateToProps, mapDispatchToProps)(MyLibrarySchoolInviteConfirm)

export { MyLibrarySchoolInviteConfirm }
